import MUITableRow from '@material-ui/core/TableRow';

export default MUITableRow;
